import { render } from "./ComplianceSingleClaimComponent.vue?vue&type=template&id=d1c14ec0&scoped=true"
import script from "./ComplianceSingleClaimComponent.vue?vue&type=script&lang=js"
export * from "./ComplianceSingleClaimComponent.vue?vue&type=script&lang=js"

import "./ComplianceSingleClaimComponent.vue?vue&type=style&index=0&id=d1c14ec0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1c14ec0"]])

export default __exports__